module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/install-317.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/vux-loader/install.md
// module id = 780
// module chunks = 430